<template>
  <div class="con-wrap" style="min-width: 1290px">
    <div class="top">
      <el-button type="primary" @click="goback">返回</el-button>
    </div>
    <el-container>
      <el-container style="flex-direction: column; margin-right: 20px">
        <realtime-data v-if="isActive == 'real'" :vin="vin"></realtime-data>
        <track-query v-if="isActive == 'track'" :vin="vin"></track-query>
        <history-data v-if="isActive == 'history'" :vin="vin"></history-data>
        <!-- <alarm-log v-if="isActive == 'alarm'" :vin="vin"></alarm-log> -->
        <illegally-inquiry
          v-if="isActive == 'illegally'"
          :vin="vin"
        ></illegally-inquiry>
        <refueling-record
          v-if="isActive == 'refueling'"
          :vin="vin"
        ></refueling-record>
        <power-record v-if="isActive == 'power'" :vin="vin"></power-record>
        <maintain-record
          v-if="isActive == 'maintain'"
          :vin="vin"
        ></maintain-record>
      </el-container>
      <el-aside width="25%">
        <p class="box-title">操作台</p>
        <div class="work-box">
          <el-row :gutter="20">
            <el-col
              v-for="item in btnList"
              :key="item.id"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
            >
              <span
                class="work-btn"
                :class="{ active: item.id == isActive }"
                v-if="hasPerm(item.limits)"
                @click="clickBtn(item.id)"
              >
                <i class="iconfont" :class="item.icon"></i>
                {{ item.name }}
              </span>
            </el-col>
          </el-row>
          <div>
            <p class="base-title">基础信息</p>
            <div class="base-info">
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">车辆型号</el-col>
                <el-col :span="14" class="base-con">
                  {{ $judgeEmpty(vehicleBaseData.vehicleModel) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">车架号</el-col>
                <el-col :span="14" class="base-con">
                  {{ $judgeEmpty(vehicleBaseData.vin) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">发动机编号</el-col>
                <el-col :span="14" class="base-con">
                  {{ $judgeEmpty(vehicleBaseData.engineCode) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">生产日期</el-col>
                <el-col :span="14" class="base-con">
                  {{ $judgeEmpty(vehicleBaseData.vehicleDate) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">车牌号</el-col>
                <el-col :span="14" class="base-con">
                  {{ $judgeEmpty(vehicleBaseData.plateNum) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">设备编号</el-col>
                <el-col :span="14" class="base-con">
                  {{ $judgeEmpty(vehicleBaseData.deviceId) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">车辆绑定人</el-col>
                <el-col :span="14" class="base-con">
                  {{ $judgeEmpty(vehicleBaseData.name) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">绑定时间</el-col>
                <el-col :span="14" class="base-con">
                  {{ $judgeEmpty(vehicleBaseData.vinBindTime) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">绑定人电话</el-col>
                <el-col :span="14" class="base-con">
                  {{ $judgeEmpty(vehicleBaseData.phone) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">使用公司</el-col>
                <el-col :span="14" class="base-con">
                  {{ $judgeEmpty(vehicleBaseData.maintainCompany) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">产权方</el-col>
                <el-col :span="14" class="base-con">
                  {{ $judgeEmpty(vehicleBaseData.propertyOwner) }}
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">证件信息</el-col>
                <el-col :span="14" class="base-con">
                  <el-col
                    :xs="5"
                    :sm="5"
                    :md="5"
                    :lg="4"
                    :xl="5"
                    class="base-label"
                  >
                    <el-button
                      type="text"
                      v-if="
                        hasPerm('vehicle:driving') &&
                          vehicleBaseData.personnelId
                      "
                      @click.stop="queryDriver()"
                      >行驶证</el-button
                    >
                  </el-col>
                  <el-col
                    :xs="5"
                    :sm="5"
                    :md="5"
                    :lg="4"
                    :xl="5"
                    class="base-label"
                  >
                    <el-button
                      type="text"
                      v-if="
                        hasPerm('vehicle:driving') &&
                          vehicleBaseData.personnelId
                      "
                      @click.stop="queryElectrician()"
                      >电工证</el-button
                    >
                  </el-col>
                  <el-col
                    :xs="7"
                    :sm="7"
                    :md="7"
                    :lg="6"
                    :xl="6"
                    class="base-label"
                  >
                    <el-button
                      type="text"
                      v-if="
                        hasPerm('vehicle:driving') &&
                          vehicleBaseData.personnelId
                      "
                      @click.stop="getQueryYearlyInspection()"
                      >年检信息</el-button
                    >
                  </el-col>
                  <el-col
                    :xs="8"
                    :sm="8"
                    :md="8"
                    :lg="6"
                    :xl="8"
                    class="base-label"
                  >
                    <el-button
                      type="text"
                      v-if="
                        hasPerm('vehicle:driving') &&
                          vehicleBaseData.personnelId
                      "
                      @click.stop="upload()"
                      >年检信息上传</el-button
                    >
                  </el-col>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" class="base-label">车辆上牌时间</el-col>
                <el-col :span="14" class="base-con">
                  <el-col :span="10" class="base-label">{{
                    VehicleInfo
                  }}</el-col>
                  <el-col :span="14" class="base-label">
                    <el-button type="text" @click.stop="setAnnualSurvey()"
                      >年检提醒设置</el-button
                    ></el-col
                  >
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-aside>
    </el-container>
    <!-- 行驶证弹窗 -->
    <el-dialog
      title="行驶证"
      :visible.sync="deiverVisible"
      class="mini-dialog deiverBody"
    >
      <p class="dialog-title">车辆照片页</p>
      <div class="imgWrap" style="padding-bottom: 10px">
        <el-image :src="vehicleUrl" :preview-src-list="vehicleUrlList">
          <div slot="error" class="errorImg">未上传</div>
        </el-image>
      </div>
      <p class="dialog-title">行驶证主页</p>
      <div class="imgWrap" style="padding-bottom: 10px">
        <el-image :src="mainPageUrl" :preview-src-list="mainPageUrlList">
          <div slot="error" class="errorImg">未上传</div>
        </el-image>
      </div>
      <p class="dialog-title">行驶证副页</p>
      <div class="imgWrap" style="padding-bottom: 10px">
        <el-image :src="vicePageUrl" :preview-src-list="vicePageUrlList">
          <div slot="error" class="errorImg">未上传</div>
        </el-image>
      </div>
      <!-- <p class="dialog-title">行驶证主页</p>
      <div v-if="mainPageUrl == ''" class="noImageWrap">
        未上传
      </div>
      <div class="imgWrap" style="padding-bottom: 10px" v-else>
        <el-image
          style="width: 440px; height: 280px"
          :src="mainPageUrl"
          :preview-src-list="mainPageUrlList"
        >
        </el-image>
      </div>
      <p class="dialog-title">行驶证副页</p>
      <div v-if="vicePageUrl == ''" class="noImageWrap">
        未上传
      </div>
      <div class="imgWrap" v-else>
        <el-image
          style="width: 440px; height: 280px"
          :src="vicePageUrl"
          :preview-src-list="vicePageUrlList"
        >
        </el-image>
      </div> -->
    </el-dialog>
    <!-- 电工证弹窗 -->
    <el-dialog
      title="电工证"
      :visible.sync="electricianVisible"
      class="mini-dialog"
    >
      <p class="dialog-title">电工证正面</p>
      <div v-if="electricianUrl == ''" class="noImageWrap">
        未上传
      </div>
      <div class="imgWrap" style="padding-bottom: 10px" v-else>
        <el-image
          style="width: 440px; height: 280px"
          :src="electricianUrl"
          :preview-src-list="electricianUrlList"
        >
        </el-image>
      </div>
      <p class="dialog-title">电工证反面</p>
      <div v-if="viceElectricianUrl == ''" class="noImageWrap">
        未上传
      </div>
      <div class="imgWrap" v-else>
        <el-image
          style="width: 440px; height: 280px"
          :src="viceElectricianUrl"
          :preview-src-list="viceElectricianUrlList"
        >
        </el-image>
      </div>
    </el-dialog>
    <!-- 年检信息弹窗 -->
    <el-dialog
      title="年检信息"
      :visible.sync="yearlyInspection"
      class="mini-dialog deiverBody"
    >
      <div style="padding-bottom: 30px">
        <p class="dialog-title-blue">行驶证年检盖章页</p>
        <div
          v-if="yearlyInspectionData.secondSheetsFileUrl == ''"
          class="noImageWrap"
        >
          未上传
        </div>
        <el-image
          v-else
          style="width: 440px; height: 280px"
          class="imgWrap"
          :src="yearlyInspectionData.secondSheetsFileUrl"
          :preview-src-list="[yearlyInspectionData.secondSheetsFileUrl]"
        >
        </el-image>
      </div>
      <div style="padding-bottom: 30px">
        <p class="dialog-title-blue">年检费用发票</p>
        <div
          v-if="yearlyInspectionData.invoiceFileUrl == ''"
          class="noImageWrap"
        >
          未上传
        </div>
        <el-image
          v-else
          style="width: 440px; height: 280px"
          class="imgWrap"
          :src="yearlyInspectionData.invoiceFileUrl"
          :preview-src-list="[yearlyInspectionData.invoiceFileUrl]"
        >
          <div slot="error" class="image-slot">
            未上传
          </div>
        </el-image>
      </div>
      <div>
        <p class="dialog-title-blue">本次年检日期</p>
        <span>{{ yearlyInspectionData.yearlyInspectionDate }}</span>
      </div>
      <!-- <div v-for="item of yearlyInspectionData" :key="item.imageId">
        <p class="dialog-title">{{ item.addTime }}上传</p>
        <div class="imgWrap" style="padding-bottom: 10px">
          <el-image
            style="width: 440px; height: 280px"
            :src="item.url"
            :preview-src-list="[item.url]"
          >
          </el-image>
        </div>
      </div> -->
    </el-dialog>
    <!-- 年检信息上传弹窗 -->
    <el-dialog
      title="年检信息上传"
      :visible.sync="yearlyInspectionUpLoad"
      class="mini-dialog deiverBody"
      @close="closeDialog"
    >
      <el-form :model="imageData" ref="imageFormData" :rules="imageRule">
        <!-- <el-form-item prop="homepageFileUrl">
          <div>
            <p class="dialog-title-blue">
              上传行驶证主页（必填）
            </p>
            <el-upload
              v-if="!imageData.homepageFileUrl"
              ref="uploadH"
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :http-request="upload"
              :limit="1"
              :on-change="
                (file, fileList) => {
                  onChange(file, fileList, 1);
                }
              "
              :on-remove="
                (file, fileList) => {
                  onRemove(file, fileList, 1);
                }
              "
              :class="logoH ? 'myUpload' : ''"
            >
              <span>上传图片</span>
            </el-upload>
          </div>
          <div v-if="imageData.homepageFileUrl" class="imageBox">
            <el-image
              style="width: 440px; height: 280px"
              class="imgWrap"
              :src="imageData.homepageFileUrl"
              :preview-src-list="[imageData.homepageFileUrl]"
            >
            </el-image>
          </div>
        </el-form-item> -->
        <el-form-item prop="secondSheetsFileUrl">
          <div>
            <p class="dialog-title-blue">上传行驶证年检盖章页（必填）</p>
            <el-upload
              v-if="!imageData.secondSheetsFileUrl"
              ref="uploadP"
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :http-request="upload"
              :limit="1"
              :on-change="
                (file, fileList) => {
                  onChange(file, fileList, 2);
                }
              "
              :on-remove="
                (file, fileList) => {
                  onRemove(file, fileList, 2);
                }
              "
              :class="logoP ? 'myUpload' : ''"
            >
              <span>上传图片</span>
            </el-upload>
          </div>
          <div v-if="imageData.secondSheetsFileUrl" class="imageBox">
            <el-image
              style="width: 440px; height: 280px"
              class="imgWrap"
              :src="imageData.secondSheetsFileUrl"
              :preview-src-list="[imageData.secondSheetsFileUrl]"
            >
            </el-image>
          </div>
        </el-form-item>
        <el-form-item prop="invoiceFileUrl">
          <div>
            <p class="dialog-title-blue">上传年检费用发票（必填）</p>
            <el-upload
              v-if="!imageData.invoiceFileUrl"
              ref="uploadI"
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :http-request="upload"
              :limit="1"
              :on-change="
                (file, fileList) => {
                  onChange(file, fileList, 3);
                }
              "
              :on-remove="
                (file, fileList) => {
                  onRemove(file, fileList, 3);
                }
              "
              :class="logoI ? 'myUpload' : ''"
            >
              <span>上传图片</span>
            </el-upload>
          </div>
          <div v-if="imageData.invoiceFileUrl" class="imageBox">
            <el-image
              style="width: 440px; height: 280px"
              class="imgWrap"
              :src="imageData.invoiceFileUrl"
              :preview-src-list="[imageData.invoiceFileUrl]"
            >
            </el-image>
          </div>
        </el-form-item>
        <el-form-item prop="yearlyInspectionDate">
          <p class="dialog-title-blue">本次年检日期（必填）</p>
          <el-date-picker
            v-model.trim="imageData.yearlyInspectionDate"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="本次年检日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="!btnVisible" @click="saveUpload"
          >确认上传</el-button
        >
        <el-button type="primary" v-if="btnVisible" @click="editor"
          >编辑</el-button
        >
        <el-button @click="cancelUpload">取消</el-button>
      </span>
    </el-dialog>
    <!-- 年检提醒设置弹窗 -->
    <el-dialog
      title="年检提醒设置"
      :visible.sync="annualSurvey"
      class="mini-dialog deiverBody"
    >
      <el-row class="desc">
        <el-col :span="2.5">设置说明：</el-col>
        <el-col :span="21">
          每年按照上牌日期的前90天、60天、30天以及当天进行4次通知和短信提醒，车主上传最新年检信息后自动取消当年后续提醒。
        </el-col>
      </el-row>
      <el-row class="time">
        <el-col :span="4.3" style="line-height: 32px">车辆上牌时间：</el-col>
        <el-col :span="19">
          <el-date-picker
            v-model="dataTime"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            placeholder="请输入车辆上牌日期"
          ></el-date-picker>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveOrUpdate">保存修改</el-button>
        <el-button @click="cancelSetAnnualSurvey">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import RealtimeData from "./components/RealtimeData.vue";
import TrackQuery from "./components/TrackQuery.vue";
import HistoryData from "./components/HistoryData.vue";
// import AlarmLog from "./components/AlarmLog.vue";
import IllegallyInquiry from "./components/IllegallyInquiry";
import RefuelingRecord from "./components/RefuelingRecord";
import PowerRecord from "./components/PowerRecord";
import MaintainRecord from "./components/MaintainRecord";
export default {
  components: {
    RealtimeData,
    TrackQuery,
    HistoryData,
    // AlarmLog,
    IllegallyInquiry,
    RefuelingRecord,
    PowerRecord,
    MaintainRecord,
  },
  data() {
    return {
      version: "",
      dialogImageUrl: "",
      dialogVisible: false,
      logoP: null, // 副页
      logoH: null, // 主页
      logoI: null, // 费用发票
      fileList: [],
      imageData: {
        homepageFileUrl: "",
        secondSheetsFileUrl: "",
        invoiceFileUrl: "",
        yearlyInspectionDate: "",
      },
      imageRule: {
        homepageFileUrl: [
          {
            required: true,
            trigger: "change",
            message: "请上传行驶证主页！",
          },
        ],
        secondSheetsFileUrl: [
          {
            required: true,
            trigger: "change",
            message: "请上传行驶证副页！",
          },
        ],
        invoiceFileUrl: [
          {
            required: true,
            trigger: "change",
            message: "请上传年检费用发票！",
          },
        ],
        yearlyInspectionDate: [
          {
            required: true,
            trigger: "blur",
            message: "请输入本次年检日期！",
          },
        ],
      },
      btnVisible: false,
      success: false,
      dataTime: "",
      yearlyInspection: false,
      yearlyInspectionData: [],
      yearlyInspectionUpLoad: false,
      imageList: [],
      annualSurvey: false,
      annualSurveyData: [],
      carUrl: "",
      deiverVisible: false,
      electricianVisible: false,
      vehicleUrl: "",
      mainPageUrl: "",
      vicePageUrl: "",
      electricianUrl: "",
      viceElectricianUrl: "",
      vehicleUrlList: [],
      mainPageUrlList: [],
      electricianUrlList: [],
      vicePageUrlList: [],
      viceElectricianUrlList: [],
      vin: "",
      btnList: [
        {
          name: "实时数据",
          icon: "icon-real-time-data",
          id: "real",
          limits: "vehicle:details:vehicle:real",
        },
        {
          name: "轨迹查询",
          icon: "icon-track-query",
          id: "track",
          limits: "vehicle:details:track",
        },
        {
          name: "历史数据",
          icon: "icon-historical-data",
          id: "history",
          limits: "vehicle:details:vehicle:history",
        },
        {
          name: "告警记录",
          icon: "icon-alarm-log",
          id: "alarm",
          limits: "vehicle:details:dynamo:warning",
        },
        // {
        //   name: "违章查询",
        //   icon: "icon-illegally-query",
        //   id: "illegally",
        //   limits: "vehicle:violation:list",
        // },
        {
          name: "加油记录",
          icon: "icon-oil-record",
          id: "refueling",
          limits: "vehicle:details:vehicle:oils",
        },
        {
          name: "发电记录",
          icon: "iconfadianjilu",
          id: "power",
          limits: "vehicle:details:dynamo:counts",
        },
        {
          name: "保养记录",
          icon: "iconbaoyang",
          id: "maintain",
          limits: "vehicle:details:maintain:reset",
        },
        {
          name: "派单管理",
          icon: "iconbaoyang",
          id: "dispatch",
          limits: "order:dispatch",
        },
        {
          name: "回单审核",
          icon: "iconbaoyang",
          id: "receipt",
          limits: "order:receipt",
        },
      ],
      vehicleBaseData: "",
      VehicleInfo: "",
      isActive: null,
      pickerOptions: {
        disabledDate: function(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    this.vin = this.$route.params.vin || sessionStorage.getItem("vin");
    this.id = this.$route.params.id;
    // 接收车辆版本号
    let vehicleModel = null;
    if (this.$route.params.version == "0A50") {
      vehicleModel = 2;
    } else if (this.$route.params.version == "0A53") {
      vehicleModel = 1;
    } else {
      vehicleModel = null;
    }
    this.version = vehicleModel;
    this.isActive =
      this.$route.params.active || sessionStorage.getItem("active");
    sessionStorage.setItem("vin", this.vin);
    sessionStorage.setItem("active", this.isActive);
    this.getBaseDate();
    this.getYearlyInspectionData();
  },
  methods: {
    // // 选择默认图片
    // chooseStaticImg(imageUrl, type) {
    //   this.getImageFileFromUrl(imageUrl, "图片.png", (item) => {
    //     if (type == 1) {
    //       this.logoH = item; //获取file对象
    //     }
    //     if (type == 2) {
    //       this.logoP = item; //获取file对象
    //     }
    //     if (type == 3) {
    //       this.logoI = item; //获取file对象
    //     }
    //   });
    // },
    // // 根据路径返回file
    // getImageFileFromUrl(url, imageName, callback) {
    //   fetch(url)
    //     .then((res) => {
    //       return res.blob();
    //     })
    //     .then((blob) => {
    //       let imgFile = new File([blob], imageName, { type: "image/jpeg" });
    //       callback(imgFile);
    //     });
    // },
    editor() {
      console.log("editor");
      this.imageData = {
        homepageFileUrl: "",
        secondSheetsFileUrl: "",
        invoiceFileUrl: "",
        yearlyInspectionDate: "",
      };
      this.logoH = this.logoP = this.logoI = null;
      this.btnVisible = !this.btnVisible;
    },
    cancelUpload() {
      this.$resetForm(this, "imageData");
      this.yearlyInspectionUpLoad = false;
    },
    closeDialog() {
      // 未上传成功图片删除
      this.logoH = this.logoP = this.logoI = null;
      this.imageRule = this.$options.data().imageRule;
      this.$refs.imageFormData.resetFields();
      this.$refs.uploadP.clearFiles();
      this.$refs.uploadI.clearFiles();
    },
    // 上传图片触发
    onChange(file, fileList, type) {
      console.log("onChange", file, fileList, type);
      switch (type) {
        case 1:
          this.logoH = file.raw;
          this.imageRule.homepageFileUrl[0].required = false;
          break;
        case 2:
          this.logoP = file.raw;
          this.imageRule.secondSheetsFileUrl[0].required = false;
          break;
        case 3:
          this.logoI = file.raw;
          this.imageRule.invoiceFileUrl[0].required = false;
          break;
      }
    },
    // 移除上传的图片时触发
    onRemove(file, fileList, type) {
      switch (type) {
        case 1:
          this.logoH = null;
          this.imageData.homepageFileUrl = "";
          this.imageRule.homepageFileUrl[0].required = true;
          break;
        case 2:
          this.logoP = null;
          this.imageData.secondSheetsFileUrl = "";
          this.imageRule.secondSheetsFileUrl[0].required = true;
          break;
        case 3:
          this.logoI = null;
          this.imageData.invoiceFileUrl = "";
          this.imageRule.invoiceFileUrl[0].required = true;
          break;
      }
    },
    // // 清除验证   在打开弹框事件以及弹框的确认和取消事件 调用此方法
    // //表单的验证规则设置为[{ required: true, message: "请输入", trigger: "blur" }],
    // //trigger: "blur"--为关键
    // clearCheck(formName) {
    //   if (this.$refs[formName]) {
    //     this.$nextTick(() => {
    //       this.$refs[formName].clearValidate();
    //     });
    //   }
    // },

    // 点击年检信息上传
    async upload() {
      // 在下一页面清除验证,让其在提交时判断
      this.$nextTick(() => {
        if (this.$refs.imageFormData) {
          this.$refs.imageFormData.clearValidate();
        }
      });
      // // 清除数据
      // if (this.success) {
      //   this.$refs.uploadP.clearFiles();
      //   this.$refs.uploadI.clearFiles();
      //   this.imageData.homepageFileUrl = "";
      //   this.imageData.secondSheetsFileUrl = "";
      //   this.imageData.invoiceFileUrl = "";
      //   this.imageData.yearlyInspectionDate = "";
      // }
      // setTimeout(() => {
      // 打开弹框
      this.yearlyInspectionUpLoad = true;
      // }, 500);
    },
    //查询年检照片
    async getQueryYearlyInspection() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/queryYearlyInspection",
        {
          params: { vin: this.vin },
        }
      );
      if (res.code == 1) {
        _this.yearlyInspection = true;
        _this.yearlyInspectionData = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    saveUpload() {
      this.$refs.imageFormData.validate(async (valid) => {
        if (valid) {
          // 上传数据
          let objData = new FormData();
          objData.append("vin", this.vin);
          objData.append("homepageFile", this.logoH);
          objData.append("secondSheetsFile", this.logoP);
          objData.append("invoiceFile", this.logoI);
          objData.append(
            "yearlyInspectionDate",
            this.imageData.yearlyInspectionDate
          );
          console.log(objData);
          let { data: res } = await this.$axios.post(
            "/api/vehicle/details/yearlyInspection",
            objData
          );
          if (res.code == 1) {
            this.$message.success("上传成功！");
            this.logoH = this.logoP = this.logoI = null;
            this.yearlyInspectionUpLoad = false;
            this.success = true;
          } else {
            this.$message.warning(res.msg);
            this.success = false;
          }
        }
      });
    },
    //查询电工证
    async queryElectrician() {
      let _this = this;
      // 先清除驾驶证数据
      _this.vehicleUrl = "";
      _this.mainPageUrl = "";
      _this.vicePageUrl = "";
      _this.vehicleUrlList = [];
      _this.mainPageUrlList = [];
      _this.vicePageUrlList = [];
      let id = _this.vehicleBaseData.personnelId;
      _this.electricianVisible = true;
      _this.certificateTitle = "电工证";
      _this.electricianUrl = "";
      _this.viceElectricianUrl = "";
      _this.electricianUrlList = [];
      _this.viceElectricianUrlList = [];
      let { data: res } = await _this.$axios.get(
        "/api/sys/image/list?belongType=5&belongId=" + id
      );
      if (res.code == 1) {
        let arr = res.data;
        for (let item in arr) {
          if (arr[item].belongType == 5) {
            if (arr[item].imageType == 2) {
              _this.electricianUrl = arr[item].url;
              _this.electricianUrlList.push(_this.electricianUrl);
            } else if (arr[item].imageType == 3) {
              _this.viceElectricianUrl = arr[item].url;
              _this.viceElectricianUrlList.push(_this.viceElectricianUrl);
            }
          }
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //查询行驶证
    async queryDriver() {
      let _this = this;
      let id = _this.vehicleBaseData.personnelId;
      this.deiverVisible = true;
      this.mainPageUrl = "";
      this.vicePageUrl = "";
      this.mainPageUrlList = [];
      this.vicePageUrlList = [];
      let { data: res } = await _this.$axios.get("/api/vehicle/driving/" + id);
      if (res.code == 1) {
        let arr = res.data;
        arr.forEach((item) => {
          if (item.belongType == 2) {
            // 筛选出行驶证的数据
            if (item.imageType == 2) {
              // 主页数据
              _this.mainPageUrl = item.url;
              _this.mainPageUrlList.push(_this.mainPageUrl);
            } else if (item.imageType == 3) {
              // 副页数据
              _this.vicePageUrl = item.url;
              _this.vicePageUrlList.push(_this.vicePageUrl);
            } else if (item.imageType == 1) {
              // 车辆照片页数据
              _this.vehicleUrl = item.url;
              _this.vehicleUrlList.push(_this.vehicleUrl);
            }
          }
        });
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 设置年检提醒
    setAnnualSurvey() {
      if (this.VehicleInfo == "未设置") {
        this.dataTime = "";
      } else {
        this.dataTime = this.VehicleInfo;
      }
      // 打开年检设置弹框
      this.annualSurvey = true;
    },
    async saveOrUpdate() {
      // 保存设置的上牌日期
      let obj = {};
      obj.vin = this.vin;
      obj.applyLicenseTimeStr = this.dataTime;
      let { data: res } = await this.$axios.post(
        "/api/vehicle/details/checkRemind",
        obj
      );
      if (res.code == 1) {
        this.$message.success(res.msg);
        // 刷新设置修改
        this.getYearlyInspectionData();
        // this.VehicleInfo = this.dataTime;
        // 关闭弹窗
        this.annualSurvey = false;
      } else {
        this.$message.warning(res.msg);
      }
    },
    cancelSetAnnualSurvey() {
      // 取消年检提醒设置弹框
      this.dataTime = "";
      this.annualSurvey = false;
    },
    goback() {
      let pathUrl = sessionStorage.getItem("pathUrl");
      let vehicleStatus = sessionStorage.getItem("vehicleStatus");
      if (pathUrl == "/monitor") {
        this.$router.push({
          name: "monitor",
          params: this.$route.params.detailPosition,
        });
        this.$store.state.MenuStore.menu_path = "运行监控";
      } else if (pathUrl == "/fullScreenMonitor") {
        this.$router.push("/monitor");
        this.$store.state.MenuStore.menu_path = "运行监控";
      } else if (pathUrl == "/AlarmMonitor") {
        this.$router.push({
          name: "AlarmMonitor",
          params: {
            alarmCurPage: sessionStorage.getItem("alarmCurPage"),
          },
        });
        this.$store.state.MenuStore.menu_path = "告警监控";
      } else if (pathUrl == "/GeologicalMonitor") {
        this.$router.push("/GeologicalMonitor");
        this.$store.state.MenuStore.menu_path = "地灾监测";
      } else if (pathUrl == "/PhotographManage") {
        this.$router.push("/PhotographManage");
        this.$store.state.MenuStore.menu_path = "地灾管理";
      } else if (pathUrl == "/UnitManagement") {
        this.$router.push("/UnitManagement");
        this.$store.state.MenuStore.menu_path = "单位管理";
      } else if (pathUrl == "/PercentManagement") {
        this.$router.push("/PercentManagement");
        this.$store.state.MenuStore.menu_path = "进度管理";
      } else if (pathUrl == "/HistoryAlarm") {
        this.$router.push({
          name: "HistoryAlarm",
          params: {
            historyAlarmCurPage: sessionStorage.getItem("historyAlarmCurPage"),
          },
        });
        this.$store.state.MenuStore.menu_path = "告警监控";
      } else {
        this.$router.push({
          name: "Vehicle",
          params: {
            id: vehicleStatus,
            version: this.version,
            currentPage: sessionStorage.getItem("vehicleCurrPage"),
          },
        });
      }
    },
    async getBaseDate() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/basic/info?vin=" + _this.vin
      );
      if (res.code == 1) {
        _this.vehicleBaseData = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getYearlyInspectionData() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/checkRemind?vin=" + _this.vin
      );
      if (res.code == 1) {
        _this.VehicleInfo = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    clickBtn(id) {
      this.isActive = id;
      switch (id) {
        case "alarm":
          this.$router.push({
            name: "AlarmMonitor",
            params: {
              alarmPlateNum: this.vehicleBaseData.plateNum,
            },
          });
          break;
        case "dispatch":
          this.$router.push({
            name: "Dispatch",
            params: {
              dispatchPlateNum: this.vehicleBaseData.plateNum,
            },
          });
          break;
        case "receipt":
          this.$router.push({
            name: "Receipt",
            params: {
              receiptPlateNum: this.vehicleBaseData.plateNum,
            },
          });
          break;
        default:
          sessionStorage.setItem("active", this.isActive);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.imageBox {
  position: relative;
  margin-left: 60px;
  width: 440px;
  height: 280px;
  .actions {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: pointer;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
  }
  .actions:hover {
    opacity: 1;
  }
}
.myUpload {
  padding: 0 60px;
  /deep/ .el-upload-list__item {
    width: 440px;
    height: 280px;
    margin: 0;
    border: none;
    display: block;
  }
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
// ::v-deep .el-upload-list__item-actions {
//   width: 440px;
//   height: 280px;
//   margin: 0;
//   border: none;
//   display: block;
// }
::v-deep .el-upload--picture-card {
  width: 120px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  border-radius: 3px;
  background: #f4f4f4;
  color: #333;
}
::v-deep .el-upload--picture-card:hover {
  color: #fff;
  background: #999;
}
.datetime-picker {
  padding-bottom: 10px;
  ::v-deep .el-date-editor.el-input {
    width: 260px;
    height: 32px;
    line-height: 32px;
    .el-input__inner {
      width: 260px;
      height: 32px;
      line-height: 32px;
      padding-left: 15px;
    }
    .el-input__prefix {
      left: auto;
      right: 10px;
      color: #333;
      .el-input__icon {
        line-height: 32px;
      }
    }
    .el-input__suffix {
      .el-input__icon.el-icon-circle-close {
        line-height: 32px;
        display: none;
      }
    }
  }
}
.dialog-title-blue {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.no_imgWrap {
  padding-bottom: 20px;
  ::v-deep .el-button--info.is-plain {
    width: 120px;
    height: 40px;
    // color: #333;
    // background: #f4f4f4;
    border: 1px solid #cccccc;
    border-radius: 3px;
  }
}
//驾驶证弹窗
.deiverBody /deep/ {
  .errorImg {
    color: #ccc;
  }
  .el-dialog {
    padding-bottom: 20px;
  }
  .el-dialog__body {
    min-height: 140px;
    max-height: 800px;
    overflow: auto;
  }
  .desc {
    font-size: 12px;
    line-height: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ee2121;
    margin-bottom: 40px !important;
  }
  .time {
    .el-input--suffix .el-input__inner {
      height: 32px;
      line-height: 32px;
      padding-left: 15px !important;
    }
    .el-input__icon {
      line-height: 28px;
    }
    .el-input__prefix {
      left: auto;
      right: 5px;
      color: #333;
    }
    .el-input__suffix {
      .el-input__icon.el-icon-circle-close {
        display: none;
      }
    }
  }
  .el-form-item__content {
    height: auto;
    line-height: normal;
    .el-input__icon {
      line-height: 32px;
    }
  }
  .imgWrap {
    position: relative;
    margin-top: 10px;
    max-width: 500px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .imgWrap img {
    width: 440px;
    height: 280px;
  }
}
.noImageWrap {
  width: 440px;
  height: 40px;
  line-height: 40px;
  color: #ccc;
}

.top {
  margin-bottom: 10px;
}
.con-wrap .box-title {
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  background: #f8f8f8;
}
.con-wrap /deep/ {
  .el-container {
    height: calc(100% - 42px);
    overflow: auto;
    .el-container {
      height: 100%;
    }
  }
  .el-aside {
    margin-right: 0;
    min-width: 312px;
  }
  .work-btn.active {
    .iconfont:hover {
      color: #fff;
    }
  }
}
.work-box {
  width: 100%;
  height: calc(100% - 31px);
  padding: 20px 5px 0 15px;
  box-sizing: border-box;
  background-color: #fff;
}
.work-btn {
  width: 110px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-bottom: 20px;
  font-size: 14px;
  color: #35abff;
  border-radius: 3px;
  display: inline-block;
  background-color: #def0fe;
  cursor: pointer;
}
.work-btn.active {
  color: #fff;
  background-color: #0094ff;
}
.work-btn i {
  font-size: 16px;
  margin-right: 10px;
}
.base-title {
  width: 100%;
  height: 24px;
  line-height: 24px;
  margin-bottom: 6px;
  font-size: 14px;
  color: #343434;
  font-weight: bold;
}
.base-info {
  height: 28px;
  line-height: 28px;
  .base-label {
    color: #343434;
    font-size: 14px;
  }
  .base-con {
    font-size: 14px;
    color: #666;
  }
}
</style>
